import * as React from 'react';
import '../style/about.css';
import '../style/utils.css';
import '../style/leadForm.css';
// load discount image from the public folder (not from the API/images endpoint)
import { Lead, LeadDto } from '../../Models/Lead'
import { useAlert } from './ui/alertProvider';
import { useResources, useComponentResources } from '../store/resourcesProvider';
import { validateName, validateEmail, validatePhone, localizeErrors } from '../Utils/validation';
import ApiClient from '../Services/ApiClient';

interface LeadFormProps {
    showDiscountImage?: boolean;
    onSubmit?: (lead: { name: string; phone: string; email: string }) => void;
}

const LeadForm: React.FC<LeadFormProps> = ({ showDiscountImage = true, onSubmit }) => {
    const [inputName, setInputName] = React.useState('');
    const [inputPhone, setInputPhone] = React.useState('');
    const [inputEmail, setInputEmail] = React.useState('');
    const [lead, setLead] = React.useState<Lead | null>(null);
    const [errors, setErrors] = React.useState<{ name?: string; phone?: string; email?: string }>({});

    const { showAlert } = useAlert();
    const resources = useResources();
    const pageRes = useComponentResources('LeadForm', ['LeadForm.NameLabel','LeadForm.PhoneLabel','LeadForm.Success','LeadForm.SubmitError','LeadForm.NetworkError','LeadForm.EmailLabel','LeadForm.Submit']);

    const handleLead = async (event) => {
        event.preventDefault();
        const leadDto: LeadDto = { email: inputEmail, name: inputName, phone: inputPhone, leadStatusId: 1, id: 0 };
    // client-side validation
    const nameErr = validateName(inputName);
    const emailErr = validateEmail(inputEmail);
    const phoneErr = validatePhone(inputPhone, 10, 10);
    const errs = { name: nameErr ?? undefined, email: emailErr ?? undefined, phone: phoneErr ?? undefined };
    // localize errors if any
    const localized = (nameErr || emailErr || phoneErr) ? localizeErrors(errs, resources) : {};
    setErrors(localized);
    if (nameErr || emailErr || phoneErr) return;
        try {
            const created = await ApiClient.post('/leads', leadDto);
            setLead(created);
            showAlert(pageRes['LeadForm.Success'] ?? resources.get('LeadForm.Success','הפרטים נשלחו בהצלחה'), 'success');
            if (onSubmit) {
                onSubmit({ name: inputName, phone: inputPhone, email: inputEmail });
            }
        } catch (ex: any) {
            // Fix: avoid mixing ?? with || without parentheses — compute message clearly
            const networkFallback = pageRes['LeadForm.NetworkError'] ?? resources.get('LeadForm.NetworkError', 'שגיאת רשת בשליחת הטופס');
            const errMsg = ex?.message || networkFallback;
            showAlert(errMsg, 'error');
        }
    };

    const handleNameChange = (event) => {
        setInputName(event.target.value);
    }

    const handlePhoneChange = (event) => {
        setInputPhone(event.target.value);
    }

    const handleEmailChange = (event) => {
        setInputEmail(event.target.value);
    }
    // Determine public URL for discount image. Works with Vite (import.meta.env.BASE_URL) or CRA (process.env.PUBLIC_URL)
    const publicBase = (typeof import.meta !== 'undefined' && (import.meta as any).env && (import.meta as any).env.BASE_URL)
        ? (import.meta as any).env.BASE_URL
        : (process.env.PUBLIC_URL || '/');
    const discountSrc = `${publicBase.replace(/\/+$|^\/+/, '') ? publicBase.replace(/\/+$/, '') + '/' : '/'}discount.png`;

    return (
        <div className="divForm">
            {showDiscountImage ? <div>
                <img src={discountSrc} alt="discount" className="imgDiscount" loading="lazy" onError={(e)=>{ const t=e.currentTarget as HTMLImageElement; t.onerror=null; t.classList.add('img-missing'); }} />
            </div> : null}
                <form onSubmit={handleLead}>
            
                <div className="divLead">
                    <label htmlFor="Name" className="lblLead">{pageRes['LeadForm.NameLabel'] ?? resources.get('LeadForm.NameLabel',' שם-full:')}</label>
                    <input type="text" id="Name" className="inpLead" name="Name" key="inp_name" value={inputName}
                        onChange={handleNameChange} />
                    {errors.name ? <div className="error-message">{errors.name}</div> : null}
                </div>
                <div className="divLead">
                    <label htmlFor="Phone" className="lblLead">{pageRes['LeadForm.PhoneLabel'] ?? resources.get('LeadForm.PhoneLabel','טלפון:')}</label>
                    <input type="text" className="inpLead" id="Phone" name="Phone" key="inp_phone" value={inputPhone}
                        onChange={handlePhoneChange}/>
                    {errors.phone ? <div className="error-message">{errors.phone}</div> : null}
            </div>
                <div className="divLead">
                    <label htmlFor="Email" className="lblLead">{pageRes['LeadForm.EmailLabel'] ?? resources.get('LeadForm.EmailLabel','אימייל:')}</label>
                    <input className="inpLead" type="text" id="Email" name="Email" key="inp_email" value={inputEmail}
                        onChange={handleEmailChange}/>
                    {errors.email ? <div className="error-message">{errors.email}</div> : null}
                </div>
                <button className="btn" onClick={handleLead}>{pageRes['LeadForm.Submit'] ?? resources.get('LeadForm.Submit','שלח')}</button>
            </form>
        </div>
    )
}

export default LeadForm;